var render = function (_h,_vm) {var _c=_vm._c;return _c('td',{staticClass:"text-right d-none d-md-table-cell"},[(_vm.props.track.duration)?[_vm._v(" "+_vm._s(_vm.parent.$formatDuration(_vm.props.track.duration))+" ")]:_vm._e()],2)}
var staticRenderFns = []

export { render, staticRenderFns }